<div class="form-holder">
  <div class="safe-area">
    <h1 class="white no-margin">"{{title}}"</h1>

    <div class="flex align-items-end content-between mt-10">
      <p *ngIf="opened" class="title white text-md no-margin">{{'POLL-ONGOING.TIMER-TITLE-SCHEDULED' | translate}}</p>
      <p *ngIf="!opened" class="title white text-md no-margin">{{'POLL-PLANNED.TIMER-TITLE' | translate}}</p>
      <div *ngIf="opened">
        <p class="white no-margin flex align-items-center" style="margin-bottom: 5px;"><span id="bullet"
            class="rounded bg-white mr-10"></span>Votants : <span class="bold ml-5">{{votersVoted}}</span></p>

        <p class="white no-margin flex align-items-center" style="margin-bottom: 5px;">
          <img width="18px" id="refresh_icon" style="margin-right: 5px; margin-left: -4px;"
            src="assets/refresh_icon.svg" class="pointer" (click)=refresh()>
          Participation : <span class="bold ml-5 yellow">{{((votersVoted/votersCount) * 100) |
            number:'1.2-2'}}%</span>
        </p>
      </div>
      <div *ngIf="hasAssessorsButtons && !opened">
        <p class="white no-margin" style="margin-bottom: 5px;"><img width="18px" id="silhouette"
            style="margin-right: 10px;" src="assets/silhouette_icon.svg">Assesseurs : <span class="bold">{{assessorCount
            -
            inactiveAssessors}}/{{assessorCount}}</span></p>
        <p-progressBar [value]="((assessorCount - inactiveAssessors) / assessorCount) * 100"
          [showValue]="false"></p-progressBar>
      </div>
    </div>

    <div id="timers" class="align-items-end">
      <div class="flex grid-template-columns-2 align-items-end white gap-5" [style.opacity]="suspended ? 0.2 : 1">
        <p class="time no-margin">{{timeDelta.days}}</p>
        <p class="measurement white">{{'TIMER.DAYS' | translate}}</p>
      </div>
      <div class="flex grid-template-columns-2 align-items-end white gap-5" [style.opacity]="suspended ? 0.2 : 1">
        <h1 class="time no-margin">{{timeDelta.hours}}</h1>
        <h1 class="measurement white">{{'TIMER.HOURS' | translate}}</h1>
      </div>
      <div class="flex grid-template-columns-2 align-items-end white gap-5" [style.opacity]="suspended ? 0.2 : 1">
        <h1 class="time no-margin">{{timeDelta.minutes}}</h1>
        <h1 class="measurement white">{{'TIMER.MINUTES' | translate}}</h1>
      </div>
      <div class="flex grid-template-columns-2 align-items-end white gap-5" [style.opacity]="suspended ? 0.2 : 1">
        <h1 class="time no-margin">{{timeDelta.seconds}}</h1>
        <h1 class="measurement white">{{'TIMER.SECONDS' | translate}}</h1>
      </div>

      <div style="margin-left: auto; height: fit-content; opacity: 1;">
        <p class="no-margin white flex align-items-end flex-row pointer" (click)="navigateToAudit()">
          <img class="clock-icon" src="assets/progress-icon.svg" height="18px" width="18px" style="margin-bottom: 3px;">
          Voir Audit d'intégrité
        </p>
      </div>
    </div>
    <!-- <div *ngIf="canSendConvocations == true" style="text-align: center;">
      <button class="blue-button" (click)=launchConvocations()>{{'TIMER.CONVOCATIONS' | translate}}</button>
    </div> -->
    <!-- <div *ngIf="canSendConvocations == false" style="text-align: center;">
      <button class="inactive-button">{{'TIMER.CONVOCATIONS' | translate}}</button>
      <div *ngIf="timeDiffHours != null" class="clock-holder">
        <img class="clock-icon" src="assets/horologe.svg">
        <p class="description">{{'POLL-PLANNED.RESEND-TIME' | translate}}{{timeDiffHours}}</p>
      </div>
    </div> -->
    <!-- <div *ngIf="hasAssessorsButtons" class="assessor-buttons">
      <button class="button-blue-dash" (click)=getInactiveAssessors()>{{'TIMER.ASS-LISTE' | translate}}</button>
      <button *ngIf="canResendAssessors == true && inactiveAssessors > 0" class="blue-button"
        (click)=relaunchAssessors()>{{'TIMER.ASS-RELAUNCH' | translate}}</button>
      <button *ngIf="canResendAssessors == false || inactiveAssessors == 0"
        class="inactive-button">{{'TIMER.ASS-RELAUNCH' | translate}}</button>
    </div>
    <div *ngIf="hasAssessorsButtons == true && canResendAssessors == false" style="text-align: center;">
      <div *ngIf="remainingAssessorTime != null" class="clock-holder">
        <img class="clock-icon" src="assets/horologe.svg">
        <p class="description">{{'POLL-PLANNED.ASS-RESEND-TIME' | translate}}{{remainingAssessorTime}}</p>
      </div>
    </div> -->
  </div>
</div>